<ng-container
	*ngIf="{
		showCurrentPasswordError: showCurrentPasswordError | async,
		buttonDisabled: buttonDisabled | async,
	} as viewData"
>
	<div class="sf-dialog-header">
		<h4 class="sf">
			{{ 'sf.shared_component.my_account.change_password.title' | translate }}
		</h4>
		<mat-icon [mat-dialog-close]="true" class="close-icon">close</mat-icon>
	</div>
	<mat-dialog-content [formGroup]="changePasswordFrom">
		<p class="sf-dialog-subtitle">{{ 'sf.shared_component.my_account.change_password.password_info' | translate }}</p>
		<div class="form-wrapper">
			<sf-error-box
				*ngIf="viewData.showCurrentPasswordError"
				[label]="'sf.shared_component.my_account.change_password.notifications.current_password'"
			></sf-error-box>
			<div class="field-wrapper password">
				<sf-input-password
					class="top"
					formControlName="currentPassword"
					[label]="'sf.shared_component.my_account.change_password.current_password' | translate"
					[placeholder]="'sf.shared_component.my_account.change_password.current_password' | translate"
				>
				</sf-input-password>
			</div>
			<div class="field-wrapper password">
				<sf-input-password
					class="top"
					formControlName="newPassword"
					[label]="'sf.shared_component.my_account.change_password.new_password' | translate"
					[placeholder]="'sf.shared_component.my_account.change_password.new_password' | translate"
					(blurEvent)="onPasswordBlur()"
				>
				</sf-input-password>
			</div>
			<div class="field-wrapper password">
				<sf-input-password
					class="top"
					formControlName="newPasswordConfirmation"
					[label]="'sf.shared_component.my_account.change_password.repeat_password' | translate"
					[placeholder]="'sf.shared_component.my_account.change_password.repeat_password' | translate"
				>
					<span *ngIf="newPasswordConfirmationControl.hasError('confirmedValidator')">
						{{ 'sf.common.validation.errors.field_password_match' | translate }}
					</span>
				</sf-input-password>
			</div>
		</div>
	</mat-dialog-content>
	<mat-dialog-actions align="end">
		<button
			(click)="onChangePasswordClick()"
			mat-flat-button
			color="accent"
			[disabled]="changePasswordFrom.invalid || viewData.buttonDisabled"
		>
			{{ 'sf.shared_component.my_account.change_password.submit' | translate | uppercase }}
		</button>
		<button mat-flat-button color="primary" [mat-dialog-close]="true">
			{{ 'sf.module.rations.my_rations.general.cancel' | translate | uppercase }}
		</button>
	</mat-dialog-actions>
</ng-container>
